import {constants, database} from 'lib_ui-services';
import editRule from '../../namespace/relation/doingEdit_namespace_relation';
import { getLocationMerge } from './locationMerge';

export default {
    verb: 'doingEdit',
    namespace: 'order',
    relation: 'order',
    priority: 10,
    description: 'View an order record with random selection support',
    logic: editOrder
};

async function editOrder(params) {
    const { data, context, dispatch } = params;
    const { namespace, relation, type } = context;

    if (type === 'random') {
        const db = database.get();
        const persistContext = { ...context, verb: 'persist', eventId: undefined };
        const results = await db.find({ 'meta.deleted': { $exists: false } }, persistContext);
        const records = (results || []).filter(r => r._id && r.title)
            // Only include records that are suspended or in any form of in progress.
            .filter(r => (/suspended|in progress/i).test(r['order:status']?.title));

        if (records.length === 0) {
            dispatch(
                {
                    // "open" orders in this case does not include New or Closed* orders.
                    message: 'No open orders found.',
                    timeout: 5000,
                    variant: 'info',
                    type: constants.notificationTypes.TOAST
                },
                { verb: 'pop', namespace: 'application', relation: 'notification' }
            );
            return { activationVerb: 'edit', record: undefined, isNew: false, namespace, relation, type };
        }

        const record = records[Math.floor(Math.random() * records.length)];
        return { activationVerb: 'edit', record, isNew: false, namespace, relation, type };
    }

    // AutoRefresh case: DetailPane triggers view with no _id/record after upsert success.
    // Nothing to view specifically — the upsert already updated the local DB and list.
    if (!data?._id && !data?.record && !data?.activeRecord) {
        return { activationVerb: 'edit', record: undefined, isNew: false, namespace, relation, type };
    }

    // locationId present (possibly null) means the click came from a TableList that opted in via
    // attachSelectedLocationId (currently only Order Confirmation's grid) -- this rule has no other
    // way to tell which grid a click came from, so that's what keeps this scoped and off every
    // other order:order grid. Resolve the same dirty/clean decision doingFind_order_order makes.
    let editParams = params;
    if (data?.locationId !== undefined && data?.record == null && data?.activeRecord == null) {
        const merge = await resolveOrderMerge(data, context, dispatch);
        if (merge) {
            editParams = { ...params, data: { ...data, ...merge } };
        }
    }

    // Normal view with a specific record: delegate to the generic edit/view logic
    const result = await editRule.logic(editParams);
    result.activationVerb = 'edit';
    return result;
}

async function resolveOrderMerge(data, context, dispatch) {
    const db = database.get();
    const persistContext = { ...context, verb: 'persist', eventId: undefined };
    const [order] = await db.getById({ _id: data._id }, persistContext);
    if (!order) return undefined;

    let location;
    if (data.locationId) {
        const [foundLocation] = await db.getById(
            { _id: data.locationId },
            { ...persistContext, namespace: 'location', relation: 'location' }
        );
        location = foundLocation;
        if (!location) {
            dispatch(
                {
                    message: 'Selected location could not be found. Please reselect a room.',
                    variant: 'warning',
                    type: constants.notificationTypes.TOAST
                },
                { verb: 'pop', namespace: 'application', relation: 'notification' }
            );
        }
    }
    return getLocationMerge(order, location);
}
